var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{on:{"click":function($event){$event.stopPropagation();return _vm.onClickFilter.apply(null, arguments)}}},[_vm._t("default",null,{"focus":_vm.focus,"onDocumentClick":_vm.onDocumentClick})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485d0aa0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vendors/vue-good-table/components/VgtBBFilterButton.vue
// module id = null
// module chunks = 